import { ActionsUnion } from "store/helper";

import { createEntityActionNames, createEntityActions, createEntitySelectorsNames } from "../actions";

import { ISubscription } from "./interfaces";

export const SUBSCRIPTION = {
  ...createEntityActionNames("SUBSCRIPTION"),
};

export const SubscriptionActionsNames = {
  ...createEntitySelectorsNames("SUBSCRIPTION"),
};

export const SubscriptionActions = {
  ...createEntityActions<ISubscription>(SUBSCRIPTION),
};

export type SubscriptionAction = ActionsUnion<typeof SubscriptionActions>;
